import React from "react";
import "./HomePage.scss";
import MainHeader from "../../Components/MainHeader/MainHeader";
import CatagoriesPreview from "../../Components/CatagoriesPreview/CatagoriesPreview";
import Footer from "../../Components/Footer/Footer";

const HomePage = (props) => {
  return (
    <div className="HomePage">
      <MainHeader />
      <CatagoriesPreview />
    </div>
  );
};

export default HomePage;
